module.exports = __webpack_public_path__ + "static/img/bg_dianxin.03ae222e.jpg";